import { TDateISO } from "api/common/types/datetime.types";

import { PublicMaintenance } from "../maintenance/maintenance.types";

export interface PclProductCheckResponse {
  is_pcl_product: boolean;
}
export interface PclCounts {
  in_evaluation: number;
  certified: number;
  archived: number;
  total: number;
}

export interface PublicPclPp {
  pp_id: number;
  pp_name: string;
  pp_short_name: string;
}

export type CertificationStatus = "Certified" | "Not Certified";

export interface PublicFeature {
  id: number;
  feature_name: string;
}

export const TESTED_FEATURES_DESCRIPTION = `The features expressly listed as "TESTED" have undergone specific evaluation
  by an approved Common Criteria Testing Lab against an applicable NIAP-approved
  Protection Profile in compliance with CNSSP-11 for use on U.S. National Security
  Systems (NSS). Any features not explicitly listed are considered "UNTESTED" and
  therefore are not explicitly eligible for acquisition or use on NSS, unless
  otherwise provided for.`;

export interface PublicPclProduct {
  am_sort: TDateISO | null;
  assigned_lab_name: string;
  certification_date: TDateISO | null;
  from_cc_portal: boolean;
  kicked_off_date?: TDateISO | null;
  product_id: number | string; // ccportal true makes this a string
  product_name: string;
  status_sort: "Archived" | "In Progress" | "Certified";
  submitting_country_id_code: string;
  submitting_country_id_name: string;
  sunset_date: TDateISO | null;
  v_id?: number | string;
  vendor_id_name: string;
  active_maintenances: PublicMaintenance[];
  protection_profiles: PublicPclPp[];
  tech_types: string[];
  features: PublicFeature[];
}

export interface PclProductDetail {
  product_id: number;
  v_id: number;
  product_name: string;
  certification_status: CertificationStatus; // one of
  certification_date: TDateISO;
  tech_type: string; // one of?
  vendor_id: {
    name: string;
    website: string;
  };
  vendor_poc: string;
  vendor_phone: string;
  vendor_email: string;
  assigned_lab: {
    cctl_name: string;
  };
  product_description: string;
  evaluation_configuration: string;
  security_evaluation_summary: string;
  environmental_strengths: string;
}
